module.exports = __webpack_public_path__ + "static/media/search-with-shadow.33547663.svg";